import React from "react"
import { Col, Row, Container } from "react-bootstrap"
import FindRehab from "../../images/find-rehab-img.png"
import "../../styles/home.scss"
import Arrow from "../../images/arrow-right-green.svg"

const LearnAboutAddiction = () => {
  return (
    <section id="learn-about-addiction">
      <Container>
        <Row className="pb-3">
          <Col md={3}>
            <img src={FindRehab} alt="" className="side-img"/>
          </Col>
          <Col md={8} className="offset-md-1 rehab-txt-wrapper">
            <div className="title-txt">Learn About Addiction Rehab</div>
            <h1>
              Find Rehab <br /> Resources & Guides
            </h1>
            <p>
              Are you hoping to learn more about addiction and rehabilitation?
              With our massive selection of educational resources about rehab,
              you can gain an understanding of your needs and the way to sober
              living. Learning about addiction rehabilitation is made easier
              with Rehab Find’s free online and offline resources. Search below
              to browse our collection of in-depth guides, first-hand accounts,
              interviews, and more.
            </p>
          </Col>
        </Row>
        <Row className="mt-2">
          <Col md={4}>
            <div className="learn-more-link">
              <a href="#">
                All Education Resources
                <span className="pl-2">
                  <img src={Arrow} alt="" style={{ margin: "0" }} />
                </span>
              </a>
            </div>
          </Col>
          <Col md={8}>
            <Row>
              <Col xs={12}  md={6}className="rehab-slide">
                <div className="rehab-slide-card">
                  <h2>Addiction Hub</h2>
                  <p>
                    Learn about physical and psychological dependence, and how
                    and why addictions develop. We provide a comprehensive look
                    at the signs and symptoms of addiction, some social and
                    behavioural signs that loved ones can look out for, and what
                    the detox and withdrawal process looks like.
                  </p>
                  <div className="rehab-find-link">
                    <a href="#">
                      Go to hub{" "}
                      <span className="pl-2">
                        <img src={Arrow} alt="" style={{ margin: "0" }} />
                      </span>
                    </a>
                  </div>
                </div>
              </Col>
              <Col xs={12} md={6} className="rehab-slide">
                <div className="rehab-slide-card">
                  <h2>Addiction Hub</h2>
                  <p>
                    Learn about physical and psychological dependence, and how
                    and why addictions develop. We provide a comprehensive look
                    at the signs and symptoms of addiction, some social and
                    behavioural signs that loved ones can look out for, and what
                    the detox and withdrawal process looks like.
                  </p>
                  <div className="rehab-find-link">
                    <a href="#">
                      Go to hub{" "}
                      <span className="pl-2">
                        <img src={Arrow} alt="" style={{ margin: "0" }} />
                      </span>
                    </a>
                  </div>
                </div>
              </Col>
            </Row>
          </Col>
        </Row>
      </Container>
    </section>
  )
}

export default LearnAboutAddiction
